import React from "react";
import Chart from "../../Charts/Chart";
import Notification from "../../../shared/items/static/notification";
import ReportNoDataInfo from "./reportNoDataInfo";

const ReportChartResult = (props) => {
  const { unitId, unitsReportData } = props;

  const data = unitsReportData.units.filter((x) => {
    return x.info.id === unitId;
  })[0];

  if (data === undefined) {
    return (
      <Notification type="warning" styles={{ heigth: "40px" }}>
        <p>{`Данные по ТС не запрошены`}</p>
      </Notification>
    );
  }

  if (Object.keys(data.tableData).length === 0) {
    return <ReportNoDataInfo info={data.info} />;
  }

  return <Chart key={data.info.id} data={data.tableData} height={500} />;
};

export default React.memo(ReportChartResult);
